import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';
import { CountrycheckComponent } from '../../taskcost/countrycheck/countrycheck.component';
import { HttpClient } from '@angular/common/http';
import { DataService } from 'src/app/services/data.service';
import { ConfirmDialog } from '../../taskcost/confirmdialog';
import { dollarUS, HSI_EMBARGO_AMOUNT, OPTICAL_EMBARGO_AMOUNT, SAR_EMBARGO_AMOUNT, STEREO_EMBARGO_AMOUNT, Video_EMBARGO_AMOUNT } from 'src/app/services/constants';
import { UtilsService } from 'src/app/services/utils.service';
import { TaskAgreementDialogComponent } from '../task-agreement-dialog/task-agreement-dialog.component';
import { catchError, EMPTY, map, switchMap } from 'rxjs';
import { MatSelect, MatSelectModule } from '@angular/material/select';
var geoParse = require('wellknown');

@Component({
  selector: 'CreateTaskConfirmDialog',
  templateUrl: 'confirmdialog.html',
  styleUrls: ['confirmdialog.scss'],
})
export class CreateTaskConfirmDialog implements OnInit {
  message = '';
  latitude = '';
  longitude = '';
  task: any;
  title = 'Create New Task';
  newTaskForm: any = FormGroup;
  outComeError: boolean = true;
  outComesensor: any;
  outComeSubmit: boolean = false;
  confirmDialogData: any = null;
  demoView: boolean = false;
  SensorsTypes:any = [];
  filteredSensorTypes: any[];
  place: any;
  country: any;
  poiWkt: string;
  geoJson: string;
  darkTheme: boolean;
  tooltipImagePath: string;
  openWater: boolean = false;
  agree: boolean = false;
  opticalValue: any = '';
  sarValue: any = '';
  stereoValue: any = '';
  hsiValue: any = '';
  videoValue: any = '';
  purposeOption: any;
  intentOption: any;
  feedsOption:any;
  selectedFeeds:any;
  isFeedsAvailable:boolean = false;
  iscloudCover:boolean = false;
  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<CreateTaskConfirmDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
    public dialog: MatDialog,
    private http: HttpClient,
    private dataService: DataService,
    private utilsService: UtilsService
  ) {
    this.message = data.message;
    this.latitude = data.latitude;
    this.longitude = data.longitude;
    this.task = data.task;
    let accuracy = 15;
    this.geoJson = `POINT (${data.longitude.toFixed(accuracy)} ${data.latitude.toFixed(accuracy)})`;
    this.poiWkt = 'Lng: ' + data.longitude.toFixed(accuracy) + '  ' + 'Lat: ' + data.latitude.toFixed(accuracy);
    if (environment.demoView === 'true') {
      this.demoView = true;
    }
    else {
      this.demoView = false;
    }

    this.dataService.darkTheme.subscribe((newValue) => {
      this.darkTheme = newValue;

      this.tooltipImagePath = this.darkTheme ? '../../../assets/images/union-dark.svg' : '../../../assets/images/union.svg';
    });
  
    this.apiService.intentOption().subscribe((response: any) => {
      this.intentOption = response;
    });


    this.newTaskForm = new FormGroup({
      taskName: new FormControl('',[Validators.minLength(5)]),
      sensorType: new FormControl(),
      resolution: new FormControl(),
      cloudCover: new FormControl(),
      target: new FormControl(),
      intent: new FormControl(),
      feeds: new FormControl(),
      latency: new FormControl('', [Validators.required, Validators.min(24), Validators.pattern(/^[0-9]\d*$/)]),
    });

    this.newTaskForm.get('sensorType')?.valueChanges.subscribe((sensor) => {
    if (sensor) {
      this.newTaskForm.get('feeds')?.enable();
      //this.isFeedsAvailable = true;
    } else {
      this.newTaskForm.get('feeds')?.disable();
      this.newTaskForm.get('feeds')?.reset();
      this.isFeedsAvailable = false;
    }
  });
    this.newTaskForm.get('feeds')?.valueChanges.subscribe((feeds) => {
      this.selectedFeeds =feeds;
    });
    this.newTaskForm.valueChanges.subscribe(() => {
      if (this.isAnyFieldEmpty()) {
        this.outComeError = true;
      } else {
        this.outComeError = false;
      }
    });

    this.newTaskForm.get('target').setValue(this.geoJson);
    this.getCountryAndPlace(this.latitude,this.longitude);
    this.setEmbargoData();
    this.apiService.getPurpose().subscribe((res: any) => {
      this.purposeOption = this.utilsService.sortPurposeOptions(res?.purposeList);
    });
  }

  ngOnInit(): void {
    this.getSensorTypes(this.data?.user?.id);
  }

  isAnyFieldEmpty(): boolean {
    for (const key of Object.keys(this.newTaskForm.controls)) {
       if (key !== 'cloudCover' && key !== 'feeds') {
        const controlValue = this.newTaskForm.get(key).value;
        if (controlValue === null || controlValue === undefined || controlValue === '') {
          return true;
        }
      }

      if (key === 'cloudCover') {
        const controlValue = this.newTaskForm.get(key).value;
        if ((controlValue === null || controlValue === undefined || controlValue === '') && this.outComesensor?.cloudCover?.length > 0) {
          return true;
        }
      }
    }
    return false;
  }

  get fields() {
    return this.newTaskForm.controls;
  }

  sensorChange(event: any) {
    this.newTaskForm.patchValue({
      resolution: '',
      cloudCover: ''
    });

    let intent = 'Internal Use';
    let target = 'POI';

    let sensorObj = {
      sensorType: event.value,
      target: target,
      intent: intent
    }

    this.apiService.getSensorDetails(sensorObj).subscribe((res: any) => {
      this.outComesensor = res;
      const cloudC: any = [];
      if (res.cloudCover) {
        for (var key in res.cloudCover) {
          cloudC.push({ key, value: res.cloudCover[key] });
        }
        this.outComesensor.cloudCover = cloudC;

        if (this.outComesensor?.cloudCover?.length === 0) {
          this.newTaskForm.get('cloudCover').disable();
           this.iscloudCover = false;
        } else {
          this.newTaskForm.get('cloudCover').enable();
          this.iscloudCover = true;
        }
      }
    });
    let selectedSensorTypes = [{
      sensor: this.newTaskForm?.value?.sensorType?.name,
    }];
      this.apiService.getInformationServices(selectedSensorTypes, this.task.taskId, this.openWater).subscribe((response: any) => {
      this.feedsOption = response.informationServices;
      this.isFeedsAvailable = this.feedsOption.length > 0;
    });
  }

  submit() {
    // Build task parameters object
    let newTaskParams: any = {
      project: this.task.project,
      projectid: this.task.projectId,
      aoiCountry: this.country,
      aoiPlace: this.place,
      taskname: this.newTaskForm?.value?.taskName,
      purpose: this.purposeOption[0],
      area: 0,
      target: JSON.stringify(geoParse(this.geoJson)),
      taskStrategy: 'Task From Collection',
      intent: this.newTaskForm?.value?.intent,
      outComeCloudCover: this.newTaskForm?.value?.cloudCover,
      outComeLatency: this.newTaskForm?.value?.latency,
      outComeResolution: this.newTaskForm?.value?.resolution,
      outComesensorType: this.newTaskForm?.value?.sensorType?.name,
      openWater: this.openWater,
      feeds: this.selectedFeeds
    };
  
    this.outComeSubmit = true;
    this.apiService.intentOption().subscribe({
      next: (response: any) => {
        try {
          const internalUseItem = response.find((item: any) => item.intent_key === 'internalUse');
          if (!newTaskParams.intent) {
            newTaskParams.intent = internalUseItem || response[0];
          }
          newTaskParams.outcomeIntent = newTaskParams.intent;
          this.apiService.checkAvailableOperators(newTaskParams).subscribe((res: any) => {
            if(res.msg == 'Failed') {
              this.outComeSubmit = false;
              this.dialog.open(CountrycheckComponent, {
                width: '40%',
                backdropClass: 'blurred',
                disableClose: true,
                data: {
                  message: 'outcomeFail',
                  response: res?.message,
                  url: '/task'
                }
              });
            } else {
              this.dialogRef.close();
              this.openTaskAgreementDialog(newTaskParams)
            }
          })
          
        } catch (error) {
          this.outComeSubmit = false;
        }
      },
      error: (error) => {
        this.outComeSubmit = false;
      }
    });
  }
  
    



  private openTaskAgreementDialog(newTaskParams: any) {
    const dialogRef = this.dialog.open(TaskAgreementDialogComponent, {
      backdropClass: 'blurr',
      disableClose: true,
      data: {
        opticalValue: this.opticalValue,
        sarValue: this.sarValue,
        stereoValue: this.stereoValue,
        hsiValue: this.hsiValue,
        videoValue: this.videoValue,
      },
    });
  
    dialogRef.afterClosed().subscribe({
      next: (result) => {
        if (result === 'agree') {
          this.callSubmitApi(newTaskParams);
        } else {
          this.outComeSubmit = false;
        }
      },
      error: (error) => {
        console.error('Dialog error:', error);
        this.outComeSubmit = false;
      }
    });
  }

  callSubmitApi(newTaskParams) {
      this.apiService.outcomeTaskSubmit(newTaskParams).subscribe((res: any) => {
        if (res?.msg === 'Success') {
          this.dialogRef.close();
          this.dialog.open(ConfirmDialog, {
            width: '40%',
            backdropClass: 'blurr',
            disableClose: true,
            data: {
              taskid: res?.taskid,
              taskname: newTaskParams['taskname'],
              response: res,
              type: 'maptask',
              from: 'maptask'
            }
          });
        } else {
          this.outComeSubmit = false;
          this.dialog.open(CountrycheckComponent, {
            width: '40%',
            backdropClass: 'blurred',
            disableClose: true,
            data: {
              message: 'outcomeFail',
              response: res?.message,
              url: '/task'
            }
          });
        }
      }, (error: any) => {
        this.outComeSubmit = false;
        this.dialog.open(CountrycheckComponent, {
          width: '40%',
          backdropClass: 'blurred',
          disableClose: true,
          data: { message: 'taskFail', url: '/task' }
        });
      });
  }

  onNoClick(): void {
    this.dialogRef.close();
    this.agree = false;
    this.outComeSubmit = false;
  }

  onClick() {
    this.agree = true;
    if (this.confirmDialogData) {
      this.dialogRef.close();
      this.dialog.open(ConfirmDialog, {
        backdropClass: 'blurr',
        disableClose: true,
        width: '40%',
        data: this.confirmDialogData,
      });
    }
  }

  onSubmit() {
    
    this.submit();
  }

  getCountryAndPlace(latitude, longitude) {
    const apiKey = environment.openCageApiKey;
    const url = `https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=${apiKey}`;
    let place: any, country: any, countryCode: any;
    let location = {
      longitude : longitude,
      latitude : latitude
    }

    this.apiService.checkIsWater(location).subscribe((res: any) => {
    this.openWater = res?.water;
    this.http.get(url).subscribe((response: any) => {
      if (response.results.length > 0) {
        const firstResult = response.results[0];
                
        if (firstResult.components?.body_of_water) {
           country = firstResult.components.body_of_water;
           place = firstResult.components.body_of_water;
           countryCode = firstResult.components.body_of_water;
        } else {
           country = firstResult.components.country;
           place = firstResult.components.city || firstResult.components.state || firstResult.components.county;
           countryCode = firstResult.components["ISO_3166-1_alpha-3"];
        }

        this.place = place;
        this.country = country;
      }
    });
  });
  }

  onKeyChange(key): void {
    const keyControl = this.newTaskForm.get(key);
    keyControl?.markAsTouched();
    keyControl?.updateValueAndValidity();
  }

  setEmbargoData() {
    this.opticalValue = dollarUS.format(OPTICAL_EMBARGO_AMOUNT);
    this.sarValue = dollarUS.format(SAR_EMBARGO_AMOUNT);
    this.stereoValue = dollarUS.format(STEREO_EMBARGO_AMOUNT);
    this.hsiValue = dollarUS.format(HSI_EMBARGO_AMOUNT);
    this.videoValue = dollarUS.format(Video_EMBARGO_AMOUNT);


    if (this.data?.user?.pointsEligible) {
      const parts = this.data.user.sensorConversionFactor.split(':');
      const conversionFactor =  parseFloat(parts[1]) / parseFloat(parts[0]);
      this.opticalValue = Math.round(OPTICAL_EMBARGO_AMOUNT * conversionFactor) + ' Points';
      this.sarValue = Math.round(SAR_EMBARGO_AMOUNT * conversionFactor) + ' Points';
      this.stereoValue = Math.round(STEREO_EMBARGO_AMOUNT * conversionFactor) + ' Points';
      this.hsiValue = Math.round(HSI_EMBARGO_AMOUNT * conversionFactor) + ' Points';
      this.videoValue = Math.round(Video_EMBARGO_AMOUNT * conversionFactor) + ' Points';
    }
  }
   getSensorTypes(userId: string) {
    this.apiService.getOutcomeSensorTypes(userId).subscribe((res: any) => {
      if (res) {
        this.SensorsTypes = this.apiService.SENSORSTYPE.filter(sensor =>
          res?.sensorTypes.includes(sensor.value)
        );        
      }
       this.filteredSensorTypes = this.SensorsTypes.filter(item => item.feasibility === true); 
    });
  }
  close(mySelect: MatSelect, event: Event): void {
    event.stopPropagation(); // Prevent propagation
    mySelect.close(); // Close the dropdown
  }
}
